import React, { createContext, useContext, useState } from 'react';

type ConfirmRequest = {
  title: string;
  content: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};

type ConfirmContextType = {
  isOpen: boolean;
  confirmRequest: ConfirmRequest;
  openConfirm: (request: ConfirmRequest) => void;
  closeConfirm: () => void;
};

export const ConfirmContext = createContext({
  isOpen: false,
  confirmRequest: {
    title: '',
    content: '',
  },
  openConfirm: () => {},
  closeConfirm: () => {},
} as ConfirmContextType);

export const useConfirmContext = () => {
  return useContext(ConfirmContext);
};

export const ConfirmProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [confirmRequest, setConfirmRequest] = useState<ConfirmRequest>({
    title: '',
    content: '',
  });

  const openConfirm = (request: ConfirmRequest) => {
    setConfirmRequest(request);
    setIsOpen(true);
  };

  const closeConfirm = () => {
    setIsOpen(false);
  };

  return (
    <ConfirmContext.Provider value={{ isOpen, confirmRequest, openConfirm, closeConfirm }}>
      {children}
    </ConfirmContext.Provider>
  );
};
